<template>
  <div class="label-input">
    <div class="label">
      <span class="text">{{labelText}}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LabelInput',

  props: {
    labelText: {
      type: String,
    },
    annotation: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input{
  text-align: left;
  color: $black;
  .label{
    display: flex;
    align-items: center;
    height: 20px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 23.4px;
    color: $black;
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 700px) {
  .label-input {
    .label {
      height: auto;
      align-items: flex-start;
      flex-direction: column;
    }
  }
}
</style>
